import React, { lazy, Suspense } from 'react';

import s from './FileView.module.sass';
import type { PdfViewerProps } from './PdfViewer';

// pdf.js n'est chargé que sur les écrans qui en ont besoin. Si son chargement échoue,
// l'aperçu retombe sur l'iframe plutôt que de casser l'écran.
const PdfViewer = lazy(() =>
  import('./PdfViewer').catch(() => ({
    default: ({ fallback }: PdfViewerProps) => <>{fallback}</>,
  }))
);

// Sur mobile, un PDF dans une iframe ne s'affiche pas : Chrome Android le télécharge, Safari iOS
// n'en montre que la première page figée. On le rend alors avec pdf.js.
const renderPdfWithPdfJs =
  !navigator.pdfViewerEnabled ||
  window.matchMedia?.('(pointer: coarse)').matches;

type Props = {
  id: string;
  srcUrl: string;
  title: string;
  size?: 'sm' | 'md' | 'lg';
};
export default function FileViewer({ id, srcUrl, title, size = 'lg' }: Props) {
  const iframe = (
    <iframe
      id={id}
      src={srcUrl}
      title={title}
      className={s[`iframe-${size}`]}
    />
  );

  return (
    <div className={s[`root-${size}`]}>
      {renderPdfWithPdfJs ? (
        <Suspense fallback={null}>
          <PdfViewer
            key={srcUrl}
            srcUrl={srcUrl}
            className={s[`iframe-${size}`]}
            firstPageOnly={size !== 'lg'}
            fallback={iframe}
          />
        </Suspense>
      ) : (
        iframe
      )}
    </div>
  );
}
